import { useFetch } from 'hooks/useFetch/useFetch'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { useSession } from 'session/src/hooks/useSession'
import useSWRImmutable from 'swr/immutable'
import { env } from 'utils/envManager/envManager'
import { isBot } from 'utils/isBot/IsBot'
import { url } from 'utils/url/url'

import type { FetchedOrder } from '../../types/purchase/purchase'
import { normalize } from './normalize'

export const useGetOrders = () => {
	const { channel } = useMasterData()
	const { fetcher } = useFetch()
	const { logged, isReady } = useSession()
	const isFetchEnabled = isReady && logged

	const { data, isLoading, error } = useSWRImmutable<FetchedOrder | null>(
		channel && isFetchEnabled && !isBot()
			? {
					url: url(
						`${env.NEXT_PUBLIC_API_DOMAIN}/ws/0/my-purchases/${channel}/purchases/banner`
					),
				}
			: null,
		fetcher,
		{}
	)

	return {
		purchaseDetails: data && normalize(data),
		isError: !!error,
		isLoading,
	}
}
